import { apiClient, unwrap } from '@/lib/apiClient';
import type { ApiSuccess } from '@/types/api';
import type { NotificationInbox } from '@/types/notification';

/**
 * Every call the notification bell makes.
 *
 * Its own feature folder rather than the institute's or the teacher's, because
 * both consoles show the same bell and a copy in each would be two inboxes that
 * drift (CLAUDE.md §3).
 *
 * No path carries a recipient — the server resolves the reader from the token.
 */
/**
 * Where a bell reads and clears its inbox. The staff consoles use
 * `notificationsApi`; the parent panel passes its own, from its own `api/`
 * folder (CLAUDE.md §6) — one bell, two inboxes behind it.
 */
export interface NotificationSource {
  inbox: () => Promise<NotificationInbox>;
  markRead: (uuid: string) => Promise<unknown>;
  markAllRead: () => Promise<unknown>;
}

export const notificationsApi = {
  /** The caller's own, newest first, with the unread count. */
  inbox: (unreadOnly = false) =>
    unwrap(
      apiClient.get<ApiSuccess<NotificationInbox>>('/institute/notifications', {
        params: unreadOnly ? { unreadOnly: 'true' } : undefined,
      }),
    ),

  markRead: (uuid: string) =>
    unwrap(apiClient.patch<ApiSuccess<null>>(`/institute/notifications/${uuid}/read`)),

  markAllRead: () =>
    unwrap(apiClient.post<ApiSuccess<{ count: number }>>('/institute/notifications/read-all')),
};
